import "./landing.css";
import Landing from "./Landing";

export default function LandingPage() {
  return (
    <div className="landing-page">
      <Landing />
    </div>
  );
}
